import { render, staticRenderFns } from "./WdfAfterSubmitMessage.vue?vue&type=template&id=ec72af9e"
import script from "./WdfAfterSubmitMessage.vue?vue&type=script&lang=js"
export * from "./WdfAfterSubmitMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports